var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06 6.39a0.5 0.5 0 0 0 -0.12 0 1.635 1.635 0 0 1 -1.58 -1.635c0 -0.905 0.73 -1.64 1.64 -1.64a1.638 1.638 0 0 1 0.06 3.275",
    stroke: "#1D2023",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37 9.69A4.965 4.965 0 0 1 6 11c-1.3 0 -2.48 -0.495 -3.37 -1.31 0.05 -0.47 0.35 -0.93 0.885 -1.29 1.37 -0.91 3.61 -0.91 4.97 0 0.535 0.36 0.835 0.82 0.885 1.29",
    stroke: "#1D2023",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11c2.761 0 5 -2.239 5 -5S8.761 1 6 1 1 3.239 1 6s2.239 5 5 5",
    stroke: "#1D2023",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.77875a15417cc6beb0bb991a17636950.svg";
export { ForwardRef as ReactComponent };